import { Button } from '@abdoo/common';
import { Box, Card, Grid, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface ManagerLandingPageTileProps {
  title: string | null;
  subtitle: ReactNode;
  description: ReactNode;
  footerButtonCaption: ReactNode;
  photoPath: string;
  onFooterButtonClick: () => void;
}

export const ManagerLandingPageTile = (props: ManagerLandingPageTileProps) => {
  const {
    title,
    subtitle,
    description,
    footerButtonCaption,
    photoPath,
    onFooterButtonClick,
  } = props;

  return (
    <Grid item justifyContent="center">
      <Card
        sx={{
          width: 300,
          borderTop: 'solid 5px',
          borderColor: 'primary.main',
          padding: '15px 10px 20px 10px',
          boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
        }}
      >
        <Grid container justifyContent="center" rowGap={2}>
          <Typography variant="h6" fontWeight="bold" align="center">
            {title}
          </Typography>
          <Typography variant="body2" align="center">
            {subtitle}
          </Typography>
          <Box
            component="img"
            src={photoPath}
            alt="Photo of an employee"
            sx={{
              width: '280px',
              borderRadius: '10px',
            }}
          />
          <Typography variant="subtitle2">{description}</Typography>
          <Button
            size={'small'}
            type="submit"
            variant="contained"
            color="primary"
            isLoading={false}
            onClick={onFooterButtonClick}
          >
            {footerButtonCaption}
          </Button>
        </Grid>
      </Card>
    </Grid>
  );
};
